import React, { useEffect } from "react";
import Layout from "../../Layout";
import HeaderOrg from "../HeaderOrg";
import RegistrationOrgForm from "./RegistrationOrgForm";
import XdrSetting from "../XdrSetting";

const RegistrationOrg = () => {
  useEffect(() => {
    const heading = document.querySelector("h1.form-title");
      if (heading) {
          heading.setAttribute("tabindex", "-1");
          heading.focus();
      }
  }, []);

  return (
    <Layout>
      <HeaderOrg />
      <main>
        <section className="layout-container">
          <div
            className="container"
            tabIndex="-1"
          >
            <div className="descript-container container-2">
              <h1 className="form-title g-clr" >Organization Registration</h1>
              <p>
                If you have an NPI (National Provider Identifier) number, enter
                the 10-digit identification number. Otherwise, fill in the
                information below, selecting the organization's specialty,
                how emails will be delivered, and the types of services enabled
                for this organization.
              </p>
            </div>
            <RegistrationOrgForm />
          </div>
        </section>
        <XdrSetting />
      </main>
    </Layout>
  );
};

export default RegistrationOrg;
